import { FormLayout, InputField, MultiSelectField } from '@app/lib/form'
import { Component, Field } from '@contember/interface'
import { LocaleSideDimension } from '../locale-side-dimension'
import { SelectLinkField } from '@app/lib/plugins/link/select-link-field'
import { Card, CardContent } from '@app/lib/ui/card'

export interface HeaderSettingsFormProps {
	over?: string & {}
}

export const HeaderSettingsForm = Component(() => (
	<FormLayout>
		<LocaleSideDimension>
			<InputField field="supportLabel" label="Support label" required />
			<InputField field="supportNumber" label="Support number" required />
			<br />
			<Card>
				<CardContent>
					<InputField field="loginLabel" label="Login label" />
					<SelectLinkField field="loginLink" label="Login link" />
				</CardContent>
			</Card>
			<br />
			<Card>
				<CardContent>
					<InputField field="sideContactEmailText" label="Side contact email text" />
					<InputField field="sideContactEmailAddress" label="Side contact email address for link" inputProps={{ type: 'email' }} />
					<InputField field="sideContactPhoneText" label="Side contact phone text" />
					<InputField field="sideContactPhoneNumber" label="Side contact phone number for link" inputProps={{ type: 'tel' }} />
					<InputField field="sideContactWhatsAppText" label="Side contact WhatsApp text" />
					<InputField
						field="sideContactWhatsAppNumber"
						label="Side contact WhatsApp number for link"
						description="International format starting with + and the country code, e.g. +420 246 035 835. Spaces are fine. Do not use 00420 or a number without the country code, the WhatsApp link would not work."
						inputProps={{ type: 'tel', placeholder: '+420 246 035 835' }}
					/>
					<MultiSelectField field="sideContactBlacklistedLinks" label="Side contact blacklisted links">
						<Field field="url" />
					</MultiSelectField>
				</CardContent>
			</Card>
			<br />
			<Card>
				<CardContent>
					<InputField field="smartsUppKey" label="SmartsUpp key for this locale" />
					<MultiSelectField field="smartsUppWhitelistedLinks" label="SmartsUpp whitelisted links">
						<Field field="url" />
						<div className="bg-slate-100 py-1 border-1 px-2 rounded-xl">
							<Field field="articleLink.locale.code" />
							<Field field="pageLink.locale.code" />
							<Field field="productLink.locale.code" />
							<Field field="technologyLink.locale.code" />
							<Field field="solutionLink.locale.code" />
							<Field field="partnerLink.locale.code" />
							<Field field="caseStudyLink.locale.code" />
							<Field field="categoryLink.locale.code" /></div>
					</MultiSelectField>
				</CardContent>
			</Card>
		</LocaleSideDimension>
	</FormLayout>
))
